import {
  MERCHANT_DASHBOARD_DETAILS_SUCCESS,
  MERCHANT_DASHBOARD_DETAILS_FAILED,
  RESET_MERCHANT_DASHBOARD_DETAILS,
  LOADING_MERCHANT_DASHBOARD_DETAILS,
  NETWORK_ERROR_MERCHANT_DASHBOARD_DETAILS,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
  networkError: "",
  invalidRequest: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_MERCHANT_DASHBOARD_DETAILS: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case MERCHANT_DASHBOARD_DETAILS_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case MERCHANT_DASHBOARD_DETAILS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case NETWORK_ERROR_MERCHANT_DASHBOARD_DETAILS: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: true,
        data: {},
      };
    }
    case RESET_MERCHANT_DASHBOARD_DETAILS: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
